<div class="login">
  <div class="login-container">
    <div class="login-card">
      <div class="login-left">
      </div>
      <div class="login-right">
        <div class="blocTop">
          <div>
            <img src="assets/img/logo.png" alt="SynthIA Logo" class="logo" />
          </div>
          <div>
            <img src="assets/img/logo_police_bleue.png" alt="SynthIA name" class="logot" />
          </div>
        </div>
        <div class="titleCo">
          Première connexion
        </div>
        <div class="text-center advert">
          Pour sécuriser le compte <strong>{{ username }}</strong>, choisissez votre mot de passe avant d'accéder à SynthIA.
        </div>
        <div>
          <form (ngSubmit)="submit()" [formGroup]="passwordForm">
            <div class="form-group">
              <input type="password" class="form-control" formControlName="password" id="password"
                autocomplete="new-password" placeholder="Nouveau mot de passe">
            </div>

            <div class="form-group">
              <input type="password" class="form-control" formControlName="password2" id="password2"
                autocomplete="new-password" placeholder="Confirmation du mot de passe">
            </div>

            @if (weakPassword) {
              <div class="error">Le mot de passe ne respecte pas les règles ci-dessous.</div>
            }
            @if (mismatch) {
              <div class="error">Les deux mots de passe ne correspondent pas.</div>
            }

            <div class="rules">
              12 caractères minimum, dont une majuscule, un chiffre et un caractère spécial (!&#64;#$%^&amp;*()_+).
            </div>

            <button type="submit" class="btn-connect" [disabled]="passwordForm.invalid || isSubmitting">
              Enregistrer mon mot de passe
            </button>
          </form>
        </div>
        <div class="text-center retrunCo">
          <a href="/login">Page de connexion</a>
        </div>
      </div>
    </div>
  </div>
</div>
